<template>
    <v-expansion-panels
            class="mb-4"
    >
        <v-expansion-panel>
            <v-expansion-panel-header>Tìm kiếm nhóm ngành</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-card class="ma-0" outlined>
                    <v-list-item class="pa-0" three-line>
                        <v-list-item-content class="pa-0">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                            label="Tìm kiếm theo tên, mô tả"
                                            placeholder="Nhập từ khóa ..."
                                            v-model="filterForm.keyword"
                                            color="primary"
                                            clearable
                                            @keyup.enter="searchSchoolLevel"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                            label="Tìm kiếm theo mã"
                                            placeholder="Nhập đúng mã ..."
                                            v-model="filterForm.code"
                                            color="primary"
                                            clearable
                                            @keyup.enter="searchSchoolLevel"
                                    />
                                </v-col>
                            </v-row>
                            <div class="text-center mb-4">
                                <v-btn class="primary mx-0" @click="searchSchoolLevel">
                                <v-icon>mdi-magnify</v-icon>Tìm kiếm
                                </v-btn>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    props: {
        filterForm: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        searchSchoolLevel() {
            Bus.$emit('search-school-level', this.filterForm)
        }
    }
}
</script>

<style scoped>

</style>